import { ArrowUp, ArrowDown, Zap } from "lucide-react";

/**
 * Smart Money (Non-Commercial) vs Retail (Non-Reportable) divergence.
 * Divergent = the two cohorts are net positioned on opposite sides.
 * The strength is the absolute spread of their long-share percentages.
 */
export default function DivergenceCell({ row, testid }) {
  const smNet = (row.noncomm_long || 0) - (row.noncomm_short || 0);
  const rNet = (row.nonrept_long || 0) - (row.nonrept_short || 0);
  const smTot = (row.noncomm_long || 0) + (row.noncomm_short || 0);
  const rTot = (row.nonrept_long || 0) + (row.nonrept_short || 0);
  if (!smTot || !rTot) {
    return <span className="text-zinc-600 text-[11px]">—</span>;
  }
  const smLongPct = (row.noncomm_long / smTot) * 100;
  const rLongPct = (row.nonrept_long / rTot) * 100;
  const divergent = Math.sign(smNet) !== Math.sign(rNet) && smNet !== 0 && rNet !== 0;
  const gap = Math.abs(smLongPct - rLongPct);
  const strong = divergent && gap >= 30;

  const ArrowSm = smNet >= 0 ? ArrowUp : ArrowDown;
  const ArrowR = rNet >= 0 ? ArrowUp : ArrowDown;
  const smCls = smNet >= 0 ? "text-pos" : "text-neg";
  const rCls = rNet >= 0 ? "text-pos" : "text-neg";

  return (
    <span
      className="inline-flex items-center gap-1.5"
      data-testid={testid}
      data-divergent={divergent ? "1" : "0"}
      title={`Smart Money ${smLongPct.toFixed(0)}% long · Retail ${rLongPct.toFixed(0)}% long · gap ${gap.toFixed(0)}pp`}
    >
      <span className="inline-flex items-center gap-0.5 text-[11px] uppercase tracking-widest">
        <span className="text-zinc-500">SM</span>
        <ArrowSm size={11} strokeWidth={2} className={smCls} />
      </span>
      <span className="text-zinc-700">/</span>
      <span className="inline-flex items-center gap-0.5 text-[11px] uppercase tracking-widest">
        <span className="text-zinc-500">RT</span>
        <ArrowR size={11} strokeWidth={2} className={rCls} />
      </span>
      {divergent ? (
        <span
          className={`inline-flex items-center gap-0.5 text-[11px] tracking-widest border px-1 leading-tight ${
            strong
              ? "border-amber-500 bg-amber-500/15 text-amber-term"
              : "border-amber-700/60 text-amber-term"
          }`}
          data-strength={strong ? "strong" : "weak"}
        >
          <Zap size={9} strokeWidth={2} />
          DIV{strong ? "+" : ""}
        </span>
      ) : (
        <span className="text-[11px] tracking-widest border border-zinc-700 text-zinc-500 px-1 leading-tight">
          ALN
        </span>
      )}
    </span>
  );
}
